import axios from 'axios';
import config from '../../../../config/index';
import { token } from '../../../login/duck/actions/login';

const inviteNewUser = (email, bundle) => axios({
  method: 'POST',
  url: `${config.host}/bundles/${bundle}/users/invite`,
  headers: {
    Authorization: `Bearer ${token()}`,
  },
  data: {
    email,
  },
});

export default inviteNewUser;
